// Generated from src/img/svg/localtrain.svg

export const Localtrain = (props) => {
  return (
    <svg height="32" viewBox="0 0 32 32" width="32" {...props}>
      <path
        d="M18.61 2c3.994 0 7.257 3.108 7.386 7L26 24a6 6 0 0 1-5.775 5.996L12 30a6 6 0 0 1-5.996-5.775L6 9.24c0-3.924 3.183-7.11 7.146-7.236zm-5.22 2c-2.907 0-5.27 2.236-5.386 5.024L8 24c0 2.142 1.678 3.974 4 4 .012-.638.595-1.033 1.141-.955a20 20 0 0 0 5.716 0c.547-.078 1.13.315 1.141.955a4 4 0 0 0 3.997-3.8L24 9.24c0-2.816-2.29-5.122-5.167-5.236zM13 23a1 1 0 0 1 1 1c0 .513-.438 1-1 1h-2a1 1 0 0 1-1-1c0-.513.407-1 1-.993zm8 0a1 1 0 0 1 1 1c0 .513-.424 1-1 1h-2a1 1 0 0 1 0-2zM18.684 6a3.303 3.303 0 0 1 3.31 3.162q-.455 7.16-.546 8.849c-.091 1.688-1.254 2.893-2.826 2.984L13.517 21c-1.601 0-2.909-1.25-2.996-2.773L10 9.272c.001-1.749 1.39-3.17 3.129-3.267zm-5.367 2c-.685 0-1.243.505-1.312 1.095q-.01.485.516 9.021a1 1 0 0 0 .879.877l5.046.007c.515 0 .94-.389.998-.936L20 9.28c.003-.66-.512-1.208-1.18-1.274z"
        fill="#282d37"
        fillRule="evenodd"
      />
    </svg>
  );
};
